/* global axios */

import ApiClient from './ApiClient';

// Copiloto IA — usa a config global de IA (Super Admin), sem hook por conta.
// Endpoint: POST /api/v1/accounts/:id/copilot/process_event
class CopilotAPI extends ApiClient {
  constructor() {
    super('copilot', { accountScoped: true });
  }

  processEvent({ type, conversationId, content, tone, force = false }) {
    const data =
      type === 'rephrase'
        ? { content, tone }
        : { conversation_display_id: conversationId };

    return axios.post(`${this.url}/process_event`, {
      event: { name: type, data },
      force,
    });
  }

  // Insights já calculados (cache) da conversa — sem chamar IA.
  getInsights(conversationId) {
    return axios.get(`${this.url}/insights`, {
      params: { conversation_display_id: conversationId },
    });
  }
}

export default new CopilotAPI();
